import CoreInputTextLeftAddon from "./CoreInputTextLeftAddon";
import createFabric from "../../../../../fabrics/createFabric";

export default createFabric("LeftAddon", CoreInputTextLeftAddon);
